<script>
import { mapState, mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
const dropdownsApi = ClientFactory.get("dropdowns");
const revenuesApi = ClientFactory.get("revenues");
const paysApi = ClientFactory.get("pays");

export default {
    props: {
        type:''
    },
    data: () => ({
        filter: {
            report_name: "",
            form_name: "",
            circulars_number: "",
            status: "",
            year: new Date().getFullYear(),
            month: 0,
        },
        dataYears: [],
        valueMonth: new Date().getMonth() + 1,
        valueYear: new Date().getFullYear(),
        vp_valueTypeReport: 2,
        syncDialog: false
    }),
    async created() {
        this.dataYears = await dropdownsApi.get(dropdownsApi.type.YEARS);
    },
    methods:{
        ...mapActions("ui", ["loading", "closeLoading", "notify"]),
        CheckRole(id) {
            return this.AppActiveUser.role.includes(id);
        },
        async search() {
            this.loading(this.$vs);
            let response = null;
            if(!this.CheckRole(27) && this.filter.status === "") {
                this.filter.status = "10"
            }
            switch(this.type){
                case 'revenues':
                    response = await revenuesApi.get_revenue(this.filter);
                    break;
                case 'pay':
                    response = await paysApi.get_pay(this.filter);
                    break;
                default: 
                    response = {}
                    console.log('Unknow to type to search');
                    break;
            }
            //console.log(response);
            //notify data
            this.notifyResponse(response.data);
            this.closeLoading();
        },
        addNewReport() {
            switch(this.type){
                case 'revenues':
                    this.$router.push({ path: `/revenues_pay/addrevenues` }).catch(() => {});
                    break;
                case 'pay':
                    this.$router.push({ path: `/revenues_pay/addpays` }).catch(() => {});
                    break;
                default:
                    console.log('Search Component unknow to navigate target')
                    break
            }
            
        },
        displaySyncReportDialog() {
            //display dialog
            this.syncDialog = true;
            switch(this.type){
                case 'revenues':
                    this.vp_valueTypeReport = 1;
                    break;
                case 'pay':
                    this.vp_valueTypeReport = 2;
                    break;
                default:
                    this.vp_valueTypeReport = -1;
                    break
            }
        },
        async sync() {
            this.loading(this.$vs);
            let response = null;
            switch(this.type){
                case 'revenues':
                    response = await revenuesApi.syncRevenueReport({year: this.valueYear, month: this.valueMonth});
                    break;
                case 'pay':
                    response = await paysApi.syncPayReport({year: this.valueYear, month: this.valueMonth});
                    break;
                default: 
                    response = {}
                    console.log('Unknown to type to sync report');
                    break;
            }
            // error handler
            if (typeof response.error !== "undefined" || response.data.status === "failed" || response.status === "failed") {
                this.closeLoading();
                return this.notify({
                    error: true,
                    text: response.error || response.message,
                });
            }
            this.syncDialog = false;
            this.closeLoading();
            this.search();
        },
        notifyResponse(data) {
            this.$emit('searchResponse', {
                type: this.type,
                data: data
            })
        }

    },
    computed: {
        ...mapState("auth", ["AppActiveUser"]),
        months() {
            return [
            {
                label: "Tất cả",
                value: 0,
            },
            {
                label: "Tháng 1",
                value: 1,
            },
            {
                label: "Tháng 2",
                value: 2,
            },
            {
                label: "Tháng 3",
                value: 3,
            },
            {
                label: "Tháng 4",
                value: 4,
            },
            {
                label: "Tháng 5",
                value: 5,
            },
            {
                label: "Tháng 6",
                value: 6,
            },
            {
                label: "Tháng 7",
                value: 7,
            },
            {
                label: "Tháng 8",
                value: 8,
            },
            {
                label: "Tháng 9",
                value: 9,
            },
            {
                label: "Tháng 10",
                value: 10,
            },
            {
                label: "Tháng 11",
                value: 11,
            },
            {
                label: "Tháng 12",
                value: 12,
            },
        ]},
        statuses() {
            if(this.CheckRole(27)) {
                return [
                    {
                        label: "Tất cả",
                        value: "",
                    },
                    {
                        label: "Chờ duyệt",
                        value: "2",
                    },
                    {
                        label: "Sử dụng",
                        value: "1",
                    },
                    {
                        label: "Ngừng sử dụng",
                        value: "0",
                    },
                ] 
            } else {
                return [
                    {
                        label: "Tất cả",
                        value: "10", // Chỉ lọc trạng thái sử dụng và ngừng sử dụng
                    },
                    {
                        label: "Sử dụng",
                        value: "1",
                    },
                    {
                        label: "Ngừng sử dụng",
                        value: "0",
                    },
                ] 
            }
            
        },
        dataTypeReport() {
            return [
                {
                    label: "Thu ngân sách",
                    value: 1,
                },
                {
                    label: "Chi ngân sách",
                    value: 2,
                },
            ]
        },
    },
}
</script>

<template>
    <div class="revenues-pay-search-component">
        <CRow class="mb-2">
            <CCol sm="6" class="mb-2">
                <CInput
                label="Tên báo cáo"
                placeholder="Điền tên báo cáo"
                v-model="filter.report_name"
                />
            </CCol>
            <CCol sm="2" class="mb-2">
                <CSelect
                label="Trạng thái"
                :options="statuses"
                :value.sync="filter.status"
                />
            </CCol>
            <CCol sm="2" class="mb-2">
                <CSelect
                label="Năm"
                :options="dataYears"
                :value.sync="filter.year"
                />
            </CCol>
            <CCol sm="2" class="mb-2">
                <CSelect
                label="Tháng"
                :options="months"
                :value.sync="filter.month"
                />
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="12" class="center">
                <vs-button v-if="CheckRole(26) === true" warn square  class="float-left custom_btn_search" @click="search()" ><i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button >
            </CCol>
        </CRow>
        <hr>
        <CRow>
            <!-- Tạm thời ẩn nút đồng bộ từ CSDL tỉnh về: && 1==0 -->
            <vs-button v-if="CheckRole(27) === true" success square class="float-left" @click="displaySyncReportDialog()"><i class='bx bx-cloud-download'></i>&nbsp;Lấy báo cáo từ CSDL Tỉnh</vs-button>
            <vs-button v-if="CheckRole(27) === true" square class="float-left" @click="addNewReport()"><i class="bx bxs-plus-square"></i>&nbsp;Thêm báo cáo</vs-button>
        </CRow>
        <vs-dialog prevent-close width="500px" v-model="syncDialog" scroll overflow-hidden>
            <template #header>
                <h4 class="not-margin">Lấy báo cáo từ CSDL Tỉnh</h4>
            </template>
            <CRow class="mt-2">
                <CCol sm="4" class="mb-2">
                    <CSelect
                        label="Loại báo cáo"
                        name="Loại báo cáo"
                        :options="dataTypeReport"
                        :value.sync="vp_valueTypeReport"
                        disabled="true"
                    />
                </CCol>
                <CCol sm="4" class="mb-2">
                    <CSelect
                        label="Năm"
                        :options="dataYears"
                        name="Năm"
                        :value.sync="valueYear"
                    />
                </CCol>
                <CCol sm="4" class="mb-2">
                    <CSelect
                        label="Tháng"
                        name="Tháng"
                        :options="months.filter(m => m.value > 0)"
                        :value.sync="valueMonth"
                    />
                </CCol>
            </CRow>
            <template #footer>
                <div class="con-footer center">
                    <vs-button square success @click="sync"><i class='bx bx-cloud-download'></i> &nbsp; Đồng bộ</vs-button>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>